export default {
    config: {
        "app_name":"Hype"
    }
};
